function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import App from 'modules/App';
import { getHeightStyle } from './helpers';
import styles from './GlucoseConcentrationLevels.pcss';
const BarChart = ({ glucoseConcentrationLevels, isInProgress, isNotingActive, onAddLevelNote })=>{
    const getBackgroundColor = (lvl, idx)=>{
        if (isInProgress) {
            return idx % 2 === 0 ? '#E0E8F2' : '#D3D3D3';
        }
        const { GLUCOSE_LEVELS_COLORS } = App.constants;
        return GLUCOSE_LEVELS_COLORS[lvl.name];
    };
    return /*#__PURE__*/ _jsx("div", {
        className: styles.bar,
        children: glucoseConcentrationLevels.map((lvl, idx)=>// eslint-disable-next-line jsx-a11y/control-has-associated-label
            /*#__PURE__*/ _jsx("a", {
                href: "",
                className: cn(styles.segment, {
                    activeNoting: isNotingActive
                }),
                style: _object_spread_props(_object_spread({}, getHeightStyle(lvl)), {
                    background: getBackgroundColor(lvl, idx)
                }),
                onClick: (evt)=>onAddLevelNote(evt, lvl)
            }, `barSegment-${lvl.name}`))
    });
};
export default BarChart;
